// | ------------------------------------------------------------------------
// | Animate on Scroll
// | ------------------------------------------------------------------------

//? https://github.com/michalsnik/aos
import AOS from "aos";

// | ------------------------------------------------------------------------

window.addEventListener("load", (event) => {
  AOS.init({
    // Global settings:
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    duration: 900,

    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    once: false, // whether animation should happen only once - while scrolling down
    mirror: true, // whether elements should animate out while scrolling past them
  });
});
